<template>
  <div class="about" style="font-size: 18px;">
    <el-table :data="showData1" v-loading="loading" stripe border fit style="width: 100%" empty-text="No Data">
      <el-table-column type="index" label="id"> </el-table-column>
      <el-table-column prop="Inflam_id" label="Inflam_id" width="100px">
		  <template slot-scope="scope">
		  	<el-link type="primary" @click="toDetail(scope.row.IID)">{{scope.row.Inflam_id}}</el-link>
		  </template>
	  </el-table-column>
      <el-table-column prop="ChEMBL_ID" label="NP_ChEMBL_ID" width="150px">
		  <template slot-scope="scope">
		  	<el-link type="primary" @click="toCHEMBL(scope.row.ChEMBL_ID)">{{scope.row.ChEMBL_ID}}</el-link>
		  </template>
	  </el-table-column>
      <el-table-column prop="Assay" label="Anti-inflammatory Assay" width="220px"></el-table-column>
      <el-table-column prop="Model" label="Model" width="120px"></el-table-column>
      <el-table-column prop="Activ_type" label="Activ_type" width="120px"> </el-table-column>
      <el-table-column prop="activ_value" label="Activ_value" width="120px"> </el-table-column>
      <el-table-column prop="Units" label="Units" width="80px" ></el-table-column>
      <el-table-column prop="Ref_info" label="Ref_info" width="600px"></el-table-column>     
    </el-table>
    <br>
    <br>
    <el-table :data="showData2" v-loading="loading" stripe border fit style="width: 100%" empty-text="No Data">
      <el-table-column type="index" label="id" width="50px"> </el-table-column>
      <el-table-column prop="Inflam_id" label="Inflam_id" width="100px"></el-table-column>
      <el-table-column prop="ChEMBL_ID" label="NP_ChEMBL_ID"  width="150px">
		  <template slot-scope="scope">
		  	<el-link type="primary" @click="toCHEMBL(scope.row.ChEMBL_ID)">IN{{scope.row.ChEMBL_ID}}</el-link>
		  </template>
	  </el-table-column>
      <el-table-column prop="Target_ChEMBL_ID" label="Target_ChEMBL_ID" width="170px"></el-table-column>
      <el-table-column prop="`Name`" label="Target_Name"  width="150px"></el-table-column>
      <el-table-column prop="Activ_type" label="Activ_type" width="150px"> </el-table-column>
      <el-table-column prop="Activ_Value" label="Activ_value" width="150px"> </el-table-column>
      <el-table-column prop="Units" label="Units" width="80px"></el-table-column>
      <el-table-column prop="Ref_info" label="Ref_info" width="600px"></el-table-column>     
    </el-table>
    
    <div class="page-warp">
      <el-pagination
        @current-change="currentChange"
        background
        layout="prev, pager, next"
        :total="tableData.length"
      />
    </div>
  </div>
</template>
<script>
export default {
  name: "about",
  data() {
    return {
      // info: {
      //   tarinfo:{},
      //   actinfo:{},
      // },  
      tableData: {},
      currentNum: 1,
      loading:false,
    };
  },
  async mounted() {
    console.log("11111")
    let res = await this.$http({
      url: "/api/rdkit/queryExInfoById",
      params: {
        id: this.$route.query.id,
      },
    })
    console.log("22222")
    if(res.data.data) {
      this.tableData = res.data.data;
      console.log(this.tableData)
    }
  },
  computed: {
    id() {
      return this.$route.query.id;
    },
    showData2() {
      console.log("----------------------------")
      let tableList = (this.tableData.tar_info || []).concat([]);
      return tableList.slice((this.currentNum - 1) * 10, this.currentNum * 10);
    },
    showData1() {
      console.log("----------------------------")
      console.log(this.tableData)
      let tableList = (this.tableData.act_info || []).concat([]);
      return tableList.slice((this.currentNum - 1) * 10, this.currentNum * 10);
    },
  },
  methods: {
    currentChange(num) {
      this.currentNum = num;
    },
	toCHEMBL(id){
		
		window.open(`https://www.ebi.ac.uk/chembl/document_report_card/${id}/`);
	},
	toDetail(id) {
		const {
			origin,
			pathname
		} = window.location;
		window.location.href = `${origin}${pathname}#/main/search/detail?id=${id}`;
		//   window.open(`${origin}${pathname}#/main/search/detail?id=${id}`);
	},
  }
  
};
</script>
<style>
	.el-table__row{
		font-size: 18px !important;
	}
	.el-divider__text, .el-link{
		font-size: 18px !important;
	}
</style>
<style scoped>
  .page-warp {
    margin-top: 10px;
    display: flex;
    justify-content: center;
  }
  .down-load {
    display: flex;
    justify-content: flex-end;
  }
  .demo-table-expand {
    font-size: 0;
  }
  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
  }
  .about {
   padding:0 100px;
    margin: 0 auto;
  }
</style>
<!--<template>-->
<!--  <div class="about">-->
<!--    <el-table-->
<!--      :data="showData"-->
<!--      v-loading="loading"-->
<!--      stripe-->
<!--      border-->
<!--      fit-->
<!--      style="width: 100%"-->
<!--      empty-text="No Data"-->
<!--    >-->
<!--      <el-table-column type="index"> </el-table-column>-->
<!--      <el-table-column prop="Assay" label="Anti-inflammatory Assay"></el-table-column>-->
<!--      <el-table-column prop="Model" label="Model"></el-table-column>-->
<!--      <el-table-column prop="Activ_type" label="Activ_type"> </el-table-column>-->
<!--      <el-table-column prop="Activ_value" label="Activ_value"> </el-table-column>-->
<!--      <el-table-column prop="Units" label="Units"></el-table-column>-->
<!--      <el-table-column prop="Ref_info" label="Ref_info"></el-table-column>     -->
<!--    </el-table>-->
<!--    <br>-->
<!--    <br>-->
<!--    <el-table-->
<!--      :data="showData"-->
<!--      v-loading="loading"-->
<!--      stripe-->
<!--      border-->
<!--      fit-->
<!--      style="width: 100%"-->
<!--      empty-text="No Data"-->
<!--    >-->
<!--      <el-table-column type="index"> </el-table-column>-->
<!--      <el-table-column prop="Target_Name" label="Target"></el-table-column>-->
<!--      <el-table-column prop="ChEMBL_ID" label="ChEMBL_ID"></el-table-column>-->
<!--      <el-table-column prop="Activ_type" label="Activ_type"> </el-table-column>-->
<!--      <el-table-column prop="Activ_value" label="Activ_value"> </el-table-column>-->
<!--      <el-table-column prop="Units" label="Units"></el-table-column>-->
<!--      <el-table-column prop="Ref_info" label="Ref_info"></el-table-column>     -->
<!--    </el-table>-->
    
    
    
    
    
<!--    <div class="page-warp">-->
<!--      <el-pagination-->
<!--        @current-change="currentChange"-->
<!--        background-->
<!--        layout="prev, pager, next"-->
<!--        :total="tableData.length"-->
<!--      />-->
<!--    </div>-->
<!--  </div>-->
<!--</template>-->
<!--<script>-->
<!--export default {-->
<!--  name: "about",-->
<!--  data() {-->
<!--    return {-->
<!--      info: {-->
<!--        tarinfo:{},-->
<!--      },  -->
<!--      tableData: [],-->
<!--      currentNum: 1,-->
<!--    };-->
<!--  },-->
<!--  computed: {-->
<!--    id() {-->
<!--      return this.$route.query.id;-->
<!--    },-->
<!--    showData() {-->
<!--      let tableList = this.tableData.concat([]);-->
<!--      return tableList.slice((this.currentNum - 1) * 10, this.currentNum * 10);-->
<!--    },-->
<!--  },-->
<!--  methods: {-->
<!--    onSubmit() {-->
<!--      this.loading = true;-->
<!--      this.currentNum = 1;-->
<!--      this.tableData = [];-->
<!--      this.$http({-->
<!--        url: "/api/rdkit/queryBySmiles",-->
<!--        params: this.form,-->
<!--        method: "get",-->
<!--      }).then((res) => {-->
<!--        this.tableData = res.data.data;-->
<!--        if (!this.tableData.length) {-->
<!--          this.$message.warning("No compound matched");-->
<!--        }-->
<!--        this.loading = false;-->
<!--      });-->
<!--    },-->
<!--    currentChange(num) {-->
<!--      this.currentNum = num;-->
<!--    },-->
<!--    handleRemove(file, fileList) {-->
<!--      console.log(file, fileList);-->
<!--    },-->
<!--    handlePreview(file) {-->
<!--      console.log(file);-->
<!--    },-->
<!--    handleExceed(files, fileList) {-->
      <!--// this.$message.warning(-->
      <!--//   `当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${-->
      <!--//     files.length + fileList.length-->
      <!--//   } 个文件`-->
      <!--// );-->
<!--    },-->
<!--    beforeRemove(file, fileList) {-->
<!--      return this.$confirm(`Sure to remove ${file.name}？`);-->
<!--    },-->
<!--    onSuccess({ data }) {-->
<!--      this.form.structure = data.join(",");-->
<!--    },-->
<!--    down() {-->
<!--      const { structure, name } = this.form;-->
<!--      this.iframeurl = `/api/exportCsv?structure=${structure}&name=${name}`;-->
<!--    },-->
<!--    toDetail(id) {-->
<!--      const { origin, pathname } = window.location;-->
<!--      window.open(`${origin}${pathname}#/main/search/detail?id=${id}`);-->
<!--    },-->
<!--  },-->
<!--  mounted() {-->
<!--    this.$http({-->
<!--      url: "/api/rdkit/queryExInfoById",-->
<!--      params: {-->
<!--        id: this.$route.query.id,-->
<!--      },-->
<!--    }).then((res) => {-->
<!--      this.tableData = res.data.data;-->
<!--    });-->
<!--  },-->
<!--};-->
<!--</script>-->

<!--<style scoped>-->
<!--  .page-warp {-->
<!--    margin-top: 10px;-->
<!--    display: flex;-->
<!--    justify-content: center;-->
<!--  }-->
<!--  .down-load {-->
<!--    display: flex;-->
<!--    justify-content: flex-end;-->
<!--  }-->
<!--  .demo-table-expand {-->
<!--    font-size: 0;-->
<!--  }-->
<!--  .demo-table-expand label {-->
<!--    width: 90px;-->
<!--    color: #99a9bf;-->
<!--  }-->
<!--  .demo-table-expand .el-form-item {-->
<!--    margin-right: 0;-->
<!--    margin-bottom: 0;-->
<!--    width: 50%;-->
<!--  }-->
<!--  .about {-->
<!--    width: 1200px;-->
<!--    margin: 0 auto;-->
<!--  }-->
<!--</style>-->